<div class="ic-selector" [class.disabled]="disabled">
	@if (label) {
		<ic-label [help]="help" [required]="required"> {{ label }} </ic-label>
	}
	<ul [class.is-labelless]="!label">
		@for (item of selectorItems$ | async; track item.generatedIdentifier) {
			<li
				#input
				data-test="selector-checkbox"
				tabindex="0"
				[class.active]="item.selected"
				[class.is-medium]="size === 'medium'"
				[class.is-small]="size === 'small'"
				[class.is-xxlarge]="size === 'xlarge'"
				(click)="selectItem(item)"
				(keydown.enter)="selectItem(item)"
			>
				<label [attr.data-test]="item.generatedIdentifier">
					<input
						class="checkbox"
						data-test="selector-input"
						[attr.disabled]="disabled || null"
						[checked]="item.selected"
						[type]="isUnsettable ? 'checkbox' : 'radio'"
						(blur)="markAsTouched()"
						(click)="$event.stopPropagation()"
					/>
					@if (itemTemplate) {
						<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item.item }" />
					} @else {
						{{ item.item }}
					}
				</label>
			</li>
		}
	</ul>
	<ng-content select=".errors" />
</div>
